"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriverTaskType = exports.DriverTaskStatus = void 0;
/**
 * @deprecated
 */
var DriverTaskStatus;
(function (DriverTaskStatus) {
    DriverTaskStatus["UNASSIGNED"] = "UNASSIGNED";
    DriverTaskStatus["ASSIGNED_TO_DRIVER"] = "ASSIGNED_TO_DRIVER";
    DriverTaskStatus["CANCELLED"] = "CANCELLED";
    DriverTaskStatus["FAILED"] = "FAILED";
    DriverTaskStatus["COMPLETED"] = "COMPLETED";
    DriverTaskStatus["IN_PROGRESS"] = "IN_PROGRESS";
    DriverTaskStatus["INCOMPLETE"] = "INCOMPLETE";
})(DriverTaskStatus || (exports.DriverTaskStatus = DriverTaskStatus = {}));
/**
 * @deprecated
 */
var DriverTaskType;
(function (DriverTaskType) {
    DriverTaskType["PICKUP"] = "PICKUP";
    DriverTaskType["DELIVERY"] = "DELIVERY";
    DriverTaskType["RELOCATION"] = "RELOCATION";
    DriverTaskType["SWAP"] = "SWAP";
    DriverTaskType["DUMP_AND_RETURN"] = "DUMP_AND_RETURN";
    DriverTaskType["LIVE_LOAD"] = "LIVE_LOAD";
    DriverTaskType["TRANSPORTATION"] = "TRANSPORTATION";
    DriverTaskType["DUMP"] = "DUMP";
})(DriverTaskType || (exports.DriverTaskType = DriverTaskType = {}));
//# sourceMappingURL=driver-task.js.map